import { EventBusContext, createEventBus } from "@/utils/contexts/events";
import { useContext } from "react";
export function useEvents() {
    return { eventBus: useContext(EventBusContext), createEventBus: createEventBus };
}
